import { IPublishInfoError } from '../../types/reducers/publishInfo';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const PUBLISH_OFFER_FAIL = 'PUBLISH_OFFER :: FAIL';

export type TPublishOfferFailAction = IReduxAction<typeof PUBLISH_OFFER_FAIL, IPublishInfoError | void>;

export const publishOfferFail = actionGenerator<typeof PUBLISH_OFFER_FAIL, IPublishInfoError | void>(
  PUBLISH_OFFER_FAIL,
);
